module.exports = __webpack_public_path__ + "static/media/colheitadeira2.1824ce4b.svg";